export const courseChat = (state = {}, action) => {
    switch (action.type) {
        case 'SET_CONVERSATION_DATA':
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
